<template>
    <div class='fileh5 upload'  v-loading="loading" element-loading-text="正在上传">
        <el-row>
            <div class="file-wrapper">
                <!-- <div class="file-item" v-for="(file,i) in dataList" :key="i">
                    <template v-if="file.loading">
                        <el-progress  type="circle" :width="120" :percentage="file.percentage"></el-progress>
                    </template>
                    <template v-else>
                        <div class="icon-style">
                            <div class="div">
                                <img :src="file.iconUrl">
                                <div class="mask">
                                    <i class="el-icon-download" @click="download(file.url)"></i>
                                    <i class="el-icon-delete" @click="deleteFile(file.id)"></i>
                                </div>
                            </div>
                            <div class="name" :title="file.name">{{file.name}}</div>
                        </div>
                    </template>
                </div> -->
                <!-- <el-upload
                    ref="upload"
                    class = "upload-demo"
                    list-type = "picture-card"
                    :multiple='true'
                    :action="url"
                    :limit="30"
                    :show-file-list="false"
                    :name = "name"
                    :auto-upload="true"
                    :with-credentials = "true"
                    :http-request="myUpload"
                    :before-upload="beforeUpload"
                    >
                    <span class="text2">文件</span>
                </el-upload>  -->
                <div class="upload-item">
                    <a href="javascript:;" class="file file2">
                        <input id="file_head2" type="file" @change="setFilePreview()">
                        <span class="text">文件</span>
                    </a>
                </div>
            </div>   
            <!-- <div class='btn' @click='save'>完成</div> -->
        </el-row>

        <!-- <el-dialog
            title="确认删除"
            :visible.sync="dialogVisible"
            append-to-body
            width="30%"
            >
            <div style="display: flex;align-items: center; margin-left:20%">
                <i class="el-icon-warning" style="color:orange;font-size:50px"></i>
                <b style="font-size:20px">确定要删除此文件？</b>
            </div>
            <span style="margin-left:30%">删除将无法恢复数据，请谨慎操作</span>
            <div style="margin-left:35%;margin-top:30px">
                <el-button type="danger" @click="secondDelete">删 除</el-button>
                <el-button @click="dialogVisible = false">取 消</el-button>
            </div>
        </el-dialog> -->
    </div>
    
</template>

<script>
import  $ from '../assets/js/jquery-3.3.1.slim.min.js';
import * as Urls from '../helper/Urls';
import * as VueHelper from '@/helper/VueHelper';
import axios from 'axios';
import OSS from 'ali-oss'
import wx from 'weixin-js-sdk'
import { Toast } from 'vant';
export default {
    props:{
        // attachIds:{type:Array},  //附件ID的数组
        fileExt : {type:String, default: "jpg,jpeg,png,bmp,gif,pdf,doc,docx,xls,xlsx,zip,rar"},
    },
    data(){
        return{
            client:new OSS({
                region: 'oss-cn-shenzhen',
                accessKeyId: 'LTAI4GGHb3kkSnv9MdPdPb4Y',
                accessKeySecret: 'yEOrbRYDSIJpgjGiZk9yTsuSAyava9',
                bucket: 'xmoty',
                timeout: 600000
            }),
            url:'',
            name:'files',
            dataList:[],
            dialogVisible:false,
            delId:'',
            fileList:[],
            num:0,
            loading:false,
            ext: ['jpg','jpeg','png','bmp','gif','pdf','doc','docx','xls','xlsx','zip','rar'],
        }
    },
    mounted(){
        this.fileList = JSON.parse(this.getUrlParam('dataList')) 
        // this.dataList&&this.dataList.map(item => {
        //     this.showAttachs(this.getAttachIds())
        // })
    },
    methods:{
        changeURLArg(url,arg,arg_val){ 
            var pattern=arg+'=([^&]*)'; 
            var replaceText=arg+'='+arg_val; 
            if(url.match(pattern)){ 
                var tmp='/('+ arg+'=)([^&]*)/gi'; 
                tmp=url.replace(eval(tmp),replaceText); 
                return tmp; 
            }else{ 
                if(url.match('[\?]')){ 
                    return url+'&'+replaceText; 
                }else{ 
                    return url+'?'+replaceText; 
                } 
            } 
            return url+'\n'+arg+'\n'+arg_val; 
        },
        save(){
            let dataList = [];
            this.dataList.map(item =>{
                dataList.push({
                    id:item.id,
                    url:item.url
                })
            })
            let str = this.changeURLArg(window.location.href,'dataList',JSON.stringify(this.fileList.concat(dataList)))
            wx.miniProgram.navigateTo({
                url:'/pages/packageMoney/pages/applyStampEditNew/main?'+ str.split('?')[1]
            })
        },
        getUrlParam(name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
            var r = window.location.href.split('?')[1]&&window.location.href.split('?')[1].match(reg); //匹配目标参数
            if (r != null){
                return decodeURIComponent(r[2]); 
            }
            return null; //返回参数值
        },
        beforeUpload(file){
            //判断文件类型限制
            if(!this.checkAccept(file)){
                return false;
            }
            //判断文件大小限制
            if(!this.checkSize(file)){
                return false;
            }
            return true;
        },
        //判断文件大小限制
        checkSize(file){
            if(this.isImage(file.name)){
                let isLt2M = file.size / 1024 / 1024 < 20;
                if (!isLt2M) {
                    this.$message.error('图片大小不能超过 20M!');
                    return false;
                }
            }else{
                let isLt2M = file.size / 1024 / 1024 < 200;
                if (!isLt2M) {
                    this.$message.error('文档大小不能超过 200M!');
                    return false;
                }
            }
            return true;
        },
        //判断文件类型限制
        checkAccept(file){
            let inst = this;
            let matchOne = false;       // 符合格式之一

            //校验文件名是否为指定类型
            let extList = inst.fileExt.split(",");
            for(var i=0; i<extList.length; i++){
                matchOne = new RegExp(extList[i]+"$").test(file.name.toLowerCase());
                if( matchOne){
                    break;
                }
            }

            if(!matchOne){
                inst._showError('上传文件的后缀名必须是: ' + inst.fileExt + ' 之一');
                return false;
            }

            return true;
        },
        //判断当前文件是否上传完毕
        getUploadFinished(){
            let fla = true;
            this.dataList.forEach(e =>{
                if(!e.id){
                    fla = false;
                }
            })
            return fla;
        },
        // 返回id数组, 通常用于提交保存
        getAttachIds(){
            return VueHelper.getIdList(this.dataList);
        },
        setFilePreview() {
            // this.fileType = 1;
			var file_head2 = document.getElementById("file_head2")
            var file = file_head2.files[0];
            file.uid = file.lastModified;
			console.log(file_head2.files[0].lastModified)
            var content = {
                file: file
            }
            this.myUpload(content);
		},
        uploadfile(upfile,name,uid){//文件上传到服务器后传给后台
            console.log(upfile.requestUrls[0])
            let inst = this
            let url = Urls.new_upload_attach
            let newUrl =  upfile.requestUrls[0].replace('http://xmoty.oss-cn-shenzhen.aliyuncs.com','https://xmyun.zhoty.com').replace('https://xmoty.oss-cn-shenzhen.aliyuncs.com','https://xmyun.zhoty.com')
            let params = {
                url:newUrl,
                size:upfile.headers['content-length']?upfile.headers['content-length']:0,
                contentType:upfile.headers['content-type'],
                name:name,
                uid:uid
            }
            this.$root.ajaxPost(url, params, function(server_data){
                inst.num = inst.num + 1
                // if(!inst.attachIds){
                //     inst.attachIds = []
                // }
                //ID列表添加ID
                // inst.attachIds.push(server_data.id)
                //文件列表添加ID
                inst.dataList.forEach(e => {
                    if(e.uid == server_data.uid){
                        e.id = server_data.id;
                        e.url = server_data.url;
                    }
                });
                if(inst.dataList.length == inst.num){
                    let dataList = [];
                    inst.dataList.map(item =>{
                        dataList.push({
                            id:item.id,
                            url:item.url
                        })
                    })
                    let str = inst.changeURLArg(window.location.href,'dataList',JSON.stringify(inst.fileList.concat(dataList)))
                    wx.miniProgram.redirectTo({
                        url:'/pages/packageMoney/pages/applyStampEditNew/main?'+ str.split('?')[1]
                    })
                }
            });
        },
        myUpload(content) {//上传文件到服务器
            this.loading = true;
            let inst = this
            let nowDate = new Date();
            let date = {
                year: nowDate.getFullYear(),
                month: nowDate.getMonth() + 1,
                date: nowDate.getDate(),
            }
            /*文件名加时间戳*/
            let _month = date.month < 10 ? '0'+date.month : date.month
            let _date = date.date < 10 ? '0'+date.date : date.date
            let systemDate = date.year +  _month  +  _date;
            let fileName = date.year+_month+_date+Date.now();
        
            /*截取文件类型*/ 
            let fileType = (content.file.name).slice((content.file.name).lastIndexOf('.')+1,content.file.name.length)

            if (!this.ext.includes(fileType)) {
                this.loading = false;
                Toast(`不支持${fileType}类型文件上传`);
                return
            }

            /**/
            inst.dataList.push({
                loading:true,
                percentage:0,
                name:content.file.name,
                uid:content.file.uid
            });
            
            /*分片上传的进度*/ 
            const progress = (p, _checkpoint) => {
                // Object的上传进度。
                // console.log(p);
                // console.log(_checkpoint); // 分片上传的断点信息。
                inst.dataList.forEach(e => {
                    if(_checkpoint && _checkpoint.file.uid == e.uid){
                        e.percentage = Number((p*100).toFixed(0));
                    }
                })
            };
           
            async function multipartUpload() {
                try {
                    // object-name可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
                    const result = await inst.client.multipartUpload('xmerp/xmfiles/'+ date.year + '/' + _month + '/' + _date + '/' + fileName + '.' + fileType, content.file, {
                        progress,
                        // meta是用户自定义的元数据，通过head接口可以获取到Object的meta数据。
                        meta: {
                            year: 2020,
                            people: 'test',
                        },
                    });
                    
                    const head = await inst.client.head('xmerp/xmfiles/'+ date.year + '/' + _month + '/' + _date + '/' + fileName + '.' + fileType );
                    console.log(head);
                    // console.log(result);


                    /*获取文件类型*/
                    let iconUrl;
                    let hz = inst.getCaption(head.res.requestUrls[0],1)
                    switch(hz){
                        case 'xls': case 'xlsx':
                            iconUrl='http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/xls.png'
                        break
                        case 'doc': case 'docx':
                            iconUrl='http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/word.png'
                        break
                        case 'ppt': case 'pptx':
                            iconUrl='http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/ppt.png'
                        break
                        case 'pdf':
                            iconUrl='http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/pdf.png'
                        break
                        case 'rar': case'zip':
                            iconUrl='http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/zip.png'
                        break
                        case 'jpg': case 'png': case 'gif': case 'jpeg': case 'bmp':
                            iconUrl=head.res.requestUrls[0]
                        break
                        default:
                            iconUrl='http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/tongyong.png'
                        break;
                    }

                    inst.dataList.forEach(e => {
                        if(content.file.uid == e.uid){
                            e.loading = false;
                            e.iconUrl = iconUrl;
                        }
                    })

                    await inst.uploadfile(head.res,content.file.name,content.file.uid)
                } catch (e) {
                    // 捕获超时异常。
                    if (e.code === 'ConnectionTimeoutError') {
                        console.log('TimeoutError');
                        // do ConnectionTimeoutError operation
                    }
                    console.log(e);
                }
            }
            multipartUpload();
            
        },

        // 用于回显数据. 调用方设置附件的id, 由这个组件请求ajax
        showAttachs(attachIds){
            if(!attachIds)return;
            let inst = this;
            let url = Urls.file_get_attach_list;
            let params = {
                'attachIds': JSON.stringify(attachIds),
            };
            console.log('params',params)
            //查找附件并显示
            this.$root.ajaxPost(url,params, function(data){
                if( ! data){
                    return;
                }

                inst.dataList = [];
                
                for(var i=0; i<data.length; i++){
                    let attach = data[i];

                    let file = {
                        'id': attach.id,
                        'name': attach.name,
                        'url': attach.url,
                        'raw': {'size': attach.size},
                    }
                    if(inst.mode == 'upload'){
                        inst._changeThumbnailIf(attach.url);
                    }
                    else{
                        // 只读模式下css是定制的, 所以要在这里加入新的属性
                        let previewUrl = inst.isImage(attach.url) ? attach.url: '/static/img/document.png';
                        file['previewUrl'] = previewUrl;
                    }
                    inst.dataList.push(file);
                }
                for(let i = 0;i<inst.dataList.length;i++){
                    let hz = inst.getCaption(inst.dataList[i].url,1);
                    switch(hz){
                        case 'xls': case 'xlsx':
                            inst.dataList[i].iconUrl='http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/xls.png';
                        break
                        case 'doc': case 'docx':
                            inst.dataList[i].iconUrl='http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/word.png';
                        break
                        case 'ppt': case 'pptx':
                            inst.dataList[i].iconUrl='http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/ppt.png';
                        break
                        case 'pdf':
                            inst.dataList[i].iconUrl='http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/pdf.png';
                        break
                        case 'zip': case 'rar':
                            inst.dataList[i].iconUrl='http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/zip.png';
                        break
                        case 'jpg': case 'png': case 'gif': case 'jpeg': case 'bmp':
                            inst.dataList[i].iconUrl = inst.dataList[i].url
                        break
                        default:
                            inst.dataList[i].iconUrl='http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/tongyong.png';
                        break;   
                    }
                }
            });

        },

        /*获取文件类型*/ 
        getCaption(obj,state){
            var index=obj.lastIndexOf("\.");
            if(state==0){
                obj=obj.substring(0,index);
            }else {
                obj=obj.substring(index+1,obj.length);
                
                
            }
            return obj;
        },

        _showError(msg){
            this.$notify.error({
                title: '错误',
                message: msg,
                duration:3000,
                position: 'bottom-right',
            });
        },
        _showSucc(msg){
            this.$notify({
                title: '成功',
                message: msg,
                type: 'success',
                duration:3000,
                position: 'bottom-right',
            });
        },

        _changeThumbnailIf (file_url){
            //如果上传的不是图片，则文件列表显示默认图片
            if(!this.isImage(file_url)){
                this.$nextTick(() =>{
                    $(".el-upload-list__item-thumbnail[src='"+file_url+"']").attr('src', '../static/img/document.png');
                })
            }
        },

        // 判断是否是图片
        isImage(data){
            let imgLi = ['jpg','jpeg','png','bmp','gif'];
            let matchOne = false; 

            //校验文件名是否为指定类型
            for(var i=0; i<imgLi.length; i++){
                matchOne = new RegExp(imgLi[i]+"$").test(data.toLowerCase());
                if( matchOne){
                    break;
                }
            }
            return matchOne;
            
        },

        deleteFile(id){
            // this.dialogVisible = true
            this.delId = id
            this.secondDelete()
        },

        secondDelete(){
            // 服务器删除
            let inst = this;
            let url = Urls.file_delete_attach;
            let params = {
                'id': this.delId,
            };
            this.$root.doPost(url,params,function(server_data){
                    
                // 用户没有登录
                if( ! inst.$root.isUserLogin(server_data)){
                    return;
                }

                // 应用错误
                if(server_data.error){
                    inst.$root.showGlobalError(server_data.error);
                    return;
                }

                // inst.dialogVisible = false

                let deleteId = inst.delId;
                for(let i = 0;i<inst.dataList.length;i++){
                    if(deleteId == inst.dataList[i].id){
                        inst.dataList.splice(i, 1);
                        break;
                    }
                }
                // let index = inst.attachIds.indexOf(deleteId);
                // if(index != -1){
                //     inst.attachIds.splice(index,1)
                // }

            });
        },
        
        download(url){
            window.open(url);
        },
        /* 上传方法 */
    }
}
</script>

<style lang="scss" scoped> 
.text2{
      display: inline-block;
      margin-top: 0.7rem;
      font-size: 0.14rem;
  }
.icon-style{
    width:1rem;
    position: relative;
    margin:0 auto;
    line-height: 0;
    img{
        width:1rem;
        height:1rem;
    }
    .el-progress-circle{
        width:1rem;
        height:1rem;
    }
    i{
        font-size: 30px;
        margin-top: 30%;
    }
    .mask{
        display: none;
        position: absolute;
        top: 0;
        left:0;
        text-align: center;
        background: rgba($color: #ccc, $alpha: 0.8);
        z-index: 1;
        border-radius: 10px;
        width: 1rem;
        height: 1rem;
        vertical-align: middle;
    }
}
.icon-style .div:hover .mask{
     display: block;
}
.upload-demo{
    display: inline-block;
    padding: 5px;
    height: 0.55rem;
    width: 0.55rem;
}
.file-wrapper{
    padding:10px;
    text-align: center;
}
.file-item{
    // width:148px;
    // height: 148px;
    text-align: center;
    display: inline-block;
    vertical-align: top;
    padding: 5px;
    .name{
        width:100%;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;/*重点，不能用block等其他*/
        -webkit-line-clamp: 2;/*重点IE和火狐不支持*/
        -webkit-box-orient: vertical;/*重点*/
        line-height: 20px;
    }
}
.btn{
    height: 0.4rem;
    text-align: center;
    line-height: .4rem;
    background: red;
    color: #fff;
}
</style>
<style lang="scss" >
.fileh5{
    height:calc(100vh);
    .el-upload--picture-card{
        height: 1rem;
        width: 1rem;
        line-height: 1.05rem;
    }
}

</style>
<style lang="scss">
.upload{
    .el-upload--picture-card{
        height: 0.55rem;
        width: 0.55rem;
        background: url('https://xmyun.zhoty.com/resource/xapp-pm/static/image/uploadicon/file-upload-type-doc.png') no-repeat left center/0.55rem 0.55rem;
        border: none;
        line-height: 0;
    }
    .upload-item{
    // width: 0.55rem;
    // padding: 0.1rem;
    text-align: center;
    font-size: 0.14rem;
    .icon{
    //   width: 0.55rem;
      height: 0.55rem;
      padding: 0.05rem;
    }
    .pic1{
      background: url('https://xmyun.zhoty.com/resource/xapp-pm/static/image/uploadicon/file-upload-type-photograph.png') no-repeat center center/0.55rem 0.55rem;
    }
  }
  .text{
      display: inline-block;
      margin-top: 0.6rem;
      color: #000;
  }
  .text2{
      display: inline-block;
      margin-top: 0.7rem;
      font-size: 0.14rem;
  }
  .file {
    width: 0.55rem;
    // height: 0.8rem;
    // padding: 0.05rem;
    position: relative;
    display: inline-block;
    overflow: hidden;
    text-decoration: none;
    text-indent: 0;
    background: url('https://xmyun.zhoty.com/resource/xapp-pm/static/image/uploadicon/file-upload-type-photograph.png') no-repeat top center/0.55rem 0.55rem;
    margin-top: 16px;
    }
    .file2 {
        background: url('https://xmyun.zhoty.com/resource/xapp-pm/static/image/uploadicon/file-upload-type-doc.png') no-repeat top center/0.55rem 0.55rem;
    }
    .file input {
        position: absolute;
        right: 0;
        top: 0;
        opacity: 0;
    }
}

</style>


// WEBPACK FOOTER //
// fileh5.vue?1534d28c